import IdentityObject from "@/src/domain/common/identity-object";
import type { DeviceCompositeData } from "@generated/n3-backend-api";

export default abstract class CompositeDataService extends IdentityObject {
  abstract fetchDeviceWithMeasurements(deviceId: number): Promise<DeviceCompositeData>;
}
